import { FCAOrganisationDetails } from '../firm/firm.types';
import { API } from '../../providers/ApiInterceptorProvider';
import { CreateMortgageClub, MortgageClub } from './mortgageClub.types';

const trimFca = (fca: string) => fca.trim();

export const mortgageClubApi = {
  getMortgageClubFromFcaRegister: async (fcaNumber: string) => {
    const { data: mortgageClub } = await API.get<FCAOrganisationDetails>(
      `/monolith/referrers/mortgage-clubs/${trimFca(fcaNumber)}/club-details`,
    );
    return mortgageClub;
  },

  getMortgageClubByFca: async (fcaNumber: string) => {
    const { data: mortgageClubs } = await API.get<MortgageClub[]>(`/monolith/referrers/mortgage-clubs`, {
      params: {
        fca: trimFca(fcaNumber),
      },
    });
    return mortgageClubs.at(0);
  },
  createMortgageClub: async (clubData: CreateMortgageClub) => {
    const { data: club } = await API.post<MortgageClub>(`/monolith/referrers/mortgage-clubs`, clubData);
    return club;
  },
};
